// extracted by mini-css-extract-plugin
export default {"waterChart":"PipeLosChart_waterChart__mJajs"};